export const endpoint = "https://ck-api.vercel.app/api";



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/graph.js